/// <reference path="../_references.ts"/>

module App.Administrative.Reviews {
	import TitleBarService = App.Helpers.TitleBarService;
	import Appointment = App.Appointments.Appointment;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import ToastService = App.Utils.ToastService;
	import OrganizationService = App.Utils.OrganizationService;
	import CustomerService = App.Customer.CustomerService;
	import PhoneNumber = App.Appointments.PhoneNumber;

	export class ReviewRequestController {
		appointment: Appointment = null;
		correctDataText: string = 'Is this the correct email or phone number to send the review request to?';
		customerName: string = '';

		email: string = null;
		phone: string = null;

		editEmailFlyout: boolean = false;
		editPhoneFlyout: boolean = false;
		edittedEmail: string = '';
		edittedPhone: string = null;
		phoneNumbers: PhoneNumber[];

		sendEmail: boolean = true;
		sendPhone: boolean = false;
		showNewEmail: boolean = false;
		showNewPhone: boolean = false;
		newEmail: string = '';
		newPhone: string = '';

		sending: boolean = false;
		loading: boolean = true;

		callsourceEnabled: boolean = false;
		reviewsEnabled: boolean = false;
		reviewChoosen: boolean = false;
		callsourceHasBrand: boolean = false;

		static $inject: string[] = ['$state', 'ReviewRequestService', 'TitleBarService', 'SelectedAppointment', 'ToastService', 'OrganizationService', 'CustomerService'];

		constructor(
			private $state: ng.ui.IStateService,
			private ReviewRequestService: ReviewRequestService,
			private TitleBarService: TitleBarService,
			private SelectedAppointment: SelectedAppointment,
			private ToastService: ToastService,
			protected OrganizationService: OrganizationService,
			private CustomerService: CustomerService
		) {
			OrganizationService.getCallsourceDetails().then((ocs) => {
				this.callsourceEnabled = ocs.data.callsource_enabled;
				this.reviewsEnabled = ocs.data.send_review_message;
				this.callsourceHasBrand = (ocs.data.callsource_brand_id || 0) > 0;
			});
			TitleBarService.set('Appointment');
			this.reviewChoosen = $state.current.data && $state.current.data.review;

			SelectedAppointment.getAppointment().then((appointment) => {
				this.setAppointment(appointment);
			});
		}

		sendReviewRequest() {
			if(!this.sendEmail && !this.sendPhone) {
				this.ToastService.show('Must check either email or phone.');
				return;
			}

			this.sending = true;
			let data: RequestReviewData = {
					service_request: this.appointment.service_request.id
				},
				func = this.reviewChoosen
					? this.ReviewRequestService.sendReviewRequest
					: this.ReviewRequestService.sendCallsourceReviewRequest;

			if(this.sendEmail) {
				data.email = this.email;
			}
			if(this.sendPhone) {
				data.phone = this.phone.toString();
			}

			func.bind(this.ReviewRequestService)(data).then((response: RequestReviewResponse) => {
				if(response.status === 'error') {
					this.ToastService.show('Error requesting review. ' + response.message);
					this.sending = false;
					return;
				}
				this.ToastService.show('Message sent successfully');
				this.$state.go('zipSolutions.administrative');
			}).catch((reason: RequestReviewResponse) => {
				this.ToastService.show('Error requesting review. ' + reason.message);
				this.sending = false;
				return;
			});
		}

		editEmail() {
			this.email = this.edittedEmail;
			this.editEmailFlyout = false;

			if (this.showNewEmail) {
				this.CustomerService.createEmail(this.appointment.service_request.customer.id, this.newEmail).then((email) => {
					this.appointment.service_request.customer.emails.push(email.data);
					this.email = this.edittedEmail = email.data.email;
					this.newEmail = '';
					this.showNewEmail = false;
					this.ToastService.show('Email created');
				});
			}
		}

		editPhone() {
			this.phone = this.edittedPhone;
			this.editPhoneFlyout = false;

			if (this.showNewPhone) {
				this.CustomerService.createPhone(this.appointment.service_request.customer.id,
					{
						number: this.newPhone,
						send_text: true
					}
				).then((phone) => {
					this.phoneNumbers.push(phone.data);
					this.phone = this.edittedPhone = phone.data.number;
					this.newPhone = '';
					this.showNewPhone = false;
					this.ToastService.show('Phone Number created');
				});
			}
		}

		setAppointment(appointment: Appointment): void {
			this.appointment = appointment;

			if(this.appointment.service_request.customer.emails.length > 0) {
				this.email = this.appointment.service_request.customer.emails[0].email;
				this.edittedEmail = this.email;
			}
			if(this.appointment.service_request.customer.phone_numbers.length > 0) {
				this.phoneNumbers = this.appointment.service_request.customer.phone_numbers.filter(number => {
					return number.send_text === true;
				});

				if (this.phoneNumbers.length > 0) {
					this.phone = this.phoneNumbers[0].number;
					this.edittedPhone = this.phone;
				}
			}

			this.customerName = this.appointment.service_request.customer.full_name;

			this.loading = false;
		}
	}
}